<template>
    <v-card :elevation="0" class="rounded-md bg-white mobile-search-results-window" :width="getWidthOfSearch">
        <v-container class="bg-orange-lighten-4 pa-3" v-if="motorbike">
            <v-row class="gc-2" align="center">
                <v-col cols="auto" class="pl-6 py-4 pr-0" v-if="$vuetify.display.mdAndUp">
                    <v-icon :icon="mdiMagnify" :size="24" color="orange"></v-icon>
                </v-col>
                <v-col cols="auto" class="pr-2" v-if="$vuetify.display.smAndDown">
                    <p class="text-subtitle-1 font-weight-bold">{{ $t('search.results_for') }}</p>
                    <v-icon :icon="mdiAtv" color="orange"></v-icon>
                    <span
                        class="text-subtitle-1 text-orange text-decoration-underline font-weight-bold ml-2">{{ motorbike
                        }}</span>
                </v-col>
                <v-col cols="auto" class="pa-0 pr-2" v-if="$vuetify.display.mdAndUp">
                    <p class="text-subtitle-1 font-weight-bold">{{ $t('search.results_for') }}</p>
                </v-col>
                <v-col cols="auto" class="pa-0" v-if="$vuetify.display.mdAndUp">
                    <v-icon :icon="mdiAtv" color="orange"></v-icon>
                </v-col>
                <v-col cols="auto" class="pa-0" v-if="$vuetify.display.mdAndUp">
                    <p class="text-subtitle-1 text-orange text-decoration-underline font-weight-bold">{{ motorbike
                        }}</p>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="pr-4">
                    <v-btn :prepend-icon="mdiClose" variant="text"
                           @click.stop="cancelFilter">
                        <p class="text-subtitle-1 text-decoration-underline">{{ $t('search.abort_filter') }} <span
                            v-if="$vuetify.display.mdAndUp">{{ $t('search.and_search_everything') }}</span></p>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-container class="pa-3" v-if="props.hits.length > 0">
            <v-row>
                <v-col class="pa-0" cols="12" md="12" sm="12" lg="3">
                    <template v-for="(_hits, index) in props.hits" :key="index">
                        <v-card class="pa-4" variant="flat"
                                v-if="_hits.sidebar && _hits.length > 0 && $vuetify.display.mdAndUp">
                            <template v-slot:title>
                                <p class="text-subtitle-1 font-weight-bold mb-1">{{ _hits.label }} ({{ _hits.length
                                    }})</p>
                            </template>
                            <v-card-text>
                                <div class="d-flex flex-column ga-3" :class="{
                                            'd-flex': $vuetify.display.mdAndUp
                                        }" v-if="_hits.show_as === 'list'">
                                    <div class="text-tiny-link c-link text-decoration-underline "
                                         @click="go(hit.url)" v-for="hit in _hits.hits"
                                         :key="`${hit.id}-${_hits.label}`" v-html="hit.name"></div>
                                </div>
                                <div v-if="_hits.show_as === 'tags'" class="d-flex flex-wrap ga-1">
                                    <v-chip
                                        v-for="hit in _hits.hits"
                                        color="orange"
                                        variant="outlined"
                                        :key="`${hit.id}-${_hits.label}`"
                                        @click="_hits.models ? selectModel(hit) : go(hit.url)"
                                    >
                                        {{ hit.name.replace(/(<([^>]+)>)/gi, '') }}
                                    </v-chip>
                                </div>
                            </v-card-text>
                        </v-card>
                        <v-divider
                            v-if="_hits.sidebar && index != hits.length - 1 && hits[index+1].hits.length > 0 && $vuetify.display.mdAndUp"></v-divider>
                    </template>
                    <v-tabs
                        v-model="mobileTab"
                        bg-color="white"
                        density="comfortable"
                        height="46"
                        class="border-b"
                        v-if="$vuetify.display.smAndDown"
                    >
                        <template v-for="(_hits, index) in props.hits" :key="index">
                            <v-tab
                                :value="index"
                                v-if="_hits.sidebar"
                                :hide-slider="true"
                                class="c-tab bg-grey-lighten-5 rounded-t border-e"
                                selected-class="c-active-tab bg-white text-orange"
                            >
                                <p class="text-tiny-link text-decoration-none text-none font-weight-bold">{{ _hits.label
                                    }} ({{ _hits.length }})</p>
                            </v-tab>
                        </template>
                    </v-tabs>
                    <v-window
                        v-if="$vuetify.display.smAndDown" v-model="mobileTab">
                        <template v-for="(_hits, index) in props.hits" :key="index">
                            <v-window-item :value="index" v-if="_hits.sidebar">
                                <v-card variant="flat">
                                    <v-card-text>
                                        <div class="d-flex flex-row ga-3 flex-wrap" v-if="_hits.show_as == 'list'">
                                            <div class="text-tiny-link c-link text-decoration-underline "
                                                 @click="go(hit.url)" v-for="hit in _hits.hits"
                                                 :key="`${hit.id}-${_hits.label}`" v-html="hit.name"></div>
                                        </div>
                                        <div v-if="_hits.show_as === 'tags'" class="d-flex ga-2 flex-wrap">
                                            <v-chip
                                                v-for="hit in _hits.hits"
                                                color="orange"
                                                variant="outlined"
                                                :key="`${hit.id}-${_hits.label}`"
                                                @click="_hits.models ? selectModel(hit) : go(hit.url)"
                                            >
                                                {{ hit.name.replace(/(<([^>]+)>)/gi, '') }}
                                            </v-chip>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-window-item>
                        </template>
                    </v-window>
                    <div v-if="!hasSidebarResults.b" class="pa-6">

                    </div>
                </v-col>
                <v-divider v-if="$vuetify.display.smAndDown"></v-divider>
                <v-divider vertical v-if="$vuetify.display.mdAndUp"></v-divider>
                <v-col class="pa-0" cols="12" sm="12" md="12" :lg="hasSidebarResults.l" :xl="hasSidebarResults.l">
                    <template v-if="hasMainbarResults" v-for="(_hits, index) in props.hits" :key="index">
                        <v-card variant="flat" class="pa-0 pb-1" v-if="!_hits.sidebar">
                            <template v-slot:title>
                                <p class="text-subtitle-1 font-weight-bold" :class="{
                                    'my-2': $vuetify.display.smAndDown,
                                    'mb-2 pa-4 pb-0 mb-n1': $vuetify.display.mdAndUp
                                }">{{ _hits.label }} ({{ _hits.length }})</p>
                            </template>
                            <v-card-text class="pa-0">
                                <div class="d-flex flex-column ga-3" v-if="_hits.show_as == 'list'">
                                    <div class="text-tiny-link c-link text-decoration-underline "
                                         v-for="hit in _hits.hits" :key="`${hit.id}-${_hits.label}`"
                                         v-html="hit.name"></div>
                                </div>
                                <v-divider v-if="$vuetify.display.smAndDown"></v-divider>

                                <div v-if="_hits.show_as === 'productitems'">
                                    <v-list
                                        density="default"
                                        lines="three">
                                        <template v-for="hit in _hits.hits"
                                                  :key="`${hit.id}-${_hits.label}`">
                                            <product-item
                                                :product="hit.product"
                                                :name="hit.name"
                                                :image="hit.image"
                                                :stock_number="hit.stock_number"
                                                :price="hit.price"
                                                :href="hit.url"
                                                :query="query"
                                                @link-click="emit('empty')"
                                            ></product-item>
                                            <v-divider></v-divider>
                                        </template>
                                        <div class="text-center mt-8">
                                            <v-btn
                                                variant="flat"
                                                color="orange"
                                                @click="findMore"
                                                class="px-8"
                                                height="48">
                                                <p class="text-subtitle-1 text-white font-weight-bold">
                                                    {{ $t('search.show_all_results') }}</p>
                                            </v-btn>
                                        </div>
                                    </v-list>
                                </div>
                            </v-card-text>
                        </v-card>
                    </template>
                    <div class="pa-6" v-else>
                        <v-container>
                            <v-row align="center">
                                <v-col cols="auto">
                                    <v-icon :icon="mdiMagnifyRemoveOutline" color="grey-lighten-2" size="64"></v-icon>
                                </v-col>
                                <v-col>
                                    <div class="d-flex flex-column" v-if="motorbike">
                                        <p class="text-h5 font-weight-bold mb-4 mt-1"
                                           v-html="$t('search.we_are_sorry_not_found', {query: props.query, motorbike: motorbike})"></p>
                                        <p class="ml-n4 mb-8">
                                            <v-btn @click="cancelFilter"
                                                   :prepend-icon="mdiClose" variant="text">
                                                <p class="text-subtitle-1 text-decoration-underline">{{ $t('search.abort_filter') }}</p>
                                            </v-btn>
                                            <span class="ml-n2 text-body-3"
                                                  v-html="$t('search.for_query_everywhere', {query: props.query})"></span>
                                        </p>
                                        <Link
                                            :href="$page.props.modelSearch.model.url"
                                            class="text-orange text-decoration-underline font-weight-medium c-em mb-8"
                                            v-html="$t('search.all_products_for', {motorbike:motorbike})"
                                        >
                                        </Link>
                                    </div>
                                    <p v-else class="text-h5 font-weight-bold">{{ $t('search.no_products_found') }}</p>
                                </v-col>
                            </v-row>
                        </v-container>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <v-container v-else class="c-not-found pa-3">
            <v-row :align="getAlign" class="pa-3 pt-4">
                <v-col cols="auto">
                    <v-icon :icon="mdiMagnifyRemoveOutline" color="grey-lighten-2" size="64"></v-icon>
                </v-col>
                <v-col>
                    <div class="d-flex flex-column" v-if="motorbike">
                        <p class="text-h5 font-weight-bold mb-4 mt-1"
                           v-html="$t('search.we_are_sorry_not_found', {query: props.query, motorbike: motorbike})"></p>
                        <p class="ml-n4 mb-8">
                            <v-btn @click="cancelFilter"
                                   :prepend-icon="mdiClose" variant="text">
                                <p class="text-subtitle-1 text-decoration-underline">{{ $t('search.abort_filter') }}</p>
                            </v-btn>
                            <span class="ml-n2 text-body-3"
                                  v-html="$t('search.for_query_everywhere', {query: props.query})"></span>
                        </p>
                        <Link
                            :href="$page.props.modelSearch.model.url"
                            class="text-orange text-decoration-underline font-weight-medium c-em mb-8"
                            v-html="$t('search.all_products_for', {motorbike:motorbike})"
                        >
                        </Link>
                    </div>
                    <p class="text-h5 font-weight-bold" v-else
                       v-html="$t('search.we_are_sorry_not_found_basic', {query: props.query})"></p>
                </v-col>
            </v-row>
            <v-row class="bg-grey-lighten-5 c-search-form">
                <v-col cols="auto" md="4" xl="4" lg="4" :class="{
                    'pa-11 pb-0 pr-0': $vuetify.display.mdAndUp,
                    'pa-5 pb-0': $vuetify.display.smAndDown
                }">
                    <div class="has-guy">
                        <p class="text-h5 font-weight-bold">{{ $t('search.send_query') }}</p>
                    </div>
                </v-col>
                <v-col :class="{
                    'pa-11': $vuetify.display.mdAndUp,
                    'pa-5': $vuetify.display.smAndDown
                }">
                    <p class="text-body-3 font-weight-medium text-black mb-2">{{ $t('search.your_email') }}: <span
                        class="text-red">*</span></p>
                    <v-text-field
                        variant="outlined"
                        :rules="[rules.required, rules.email]"
                        density="compact"
                        autocomplete="email"
                        v-model="email"
                        type="email"
                        validate-on="blur"
                        bg-color="white"
                    ></v-text-field>
                    <p class="text-body-3 font-weight-medium text-black mb-2">{{ $t('search.query') }}: <span
                        class="text-red">*</span></p>
                    <v-textarea
                        variant="outlined"
                        rows="4"
                        :rules="[rules.required]"
                        v-model="question"
                        bg-color="white"
                        :placeholder="$t('search.cant_find_xyz', {query: props.query})"
                    >
                    </v-textarea>
                    <v-row align="center">
                        <v-col>
                            <div @click="go(route('gdpr'))" class="text-tiny-link text-grey c-em"
                                 v-html="$t('search.gdpr')"></div>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                color="orange"
                                variant="flat"
                                class="px-8"
                                :loading="loading"
                                :height="48"
                                @click="sendQuestion"
                            >
                                <p class="text-subtitle-1 font-weight-bold text-white">
                                    {{ $t('search.send_query_action') }}</p>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script setup>
import { mdiClose, mdiMagnify, mdiMagnifyRemoveOutline, mdiAtv } from '@mdi/js';
import { computed, inject, nextTick, ref, watch } from 'vue';
import { Link, router, usePage } from '@inertiajs/vue3';
import { useDisplay } from 'vuetify';
import ProductItem from './ProductItem.vue';
import { usePriceStore } from '../../../motonet/modules/eshop/stores/price.js';
import pinia from '../../../plugins/pinia.js';
import { useSearchStore } from './store/search.js';
import { useOverlayModalsStore } from './store/overlayModals.js';

const mobileTab = ref();
const props = defineProps({
    query: String,
    hits: [Array, Object],
});

watch(() => props.hits, () => {
    mobileTab.value = 1;
}, { immediate: true, deep: true });

const route = inject('route');
const getAlign = computed(() => {
    if (motorbike.value) return 'start';
    return 'center';
});

const store = usePriceStore(pinia);
watch(() => props.hits, (val => {
    if (!usePage().props.customer.id) {
        return;
    }
    if (val && !val.notFound) {
        const products = val.find((el) => el.show_as === 'productitems')?.hits ?? [];
        const ids = [];
        const length = products.length;
        for (let i = 0; i < length; i++) {
            if (store.prices[products[i].id]) {
                products[i].price = store.prices[products[i].id].nice_price.replace('CZK', 'Kč');
            } else {
                ids.push(products[i].id);
            }
        }
        if (ids.length) {
            store.loadPricesFromApi(ids, usePage().props.customer.id).then(prices => {
                const length = ids.length;
                for (let i = 0; i < length; i++) {
                    const product = products.find(p => p.id === ids[i]);
                    if (product && prices[product.id]) {
                        product.price = prices[product.id].nice_price.replace('CZK', 'Kč');
                    }
                }
            });
        }
    }
}), { immediate: true, deep: true });


const emit = defineEmits(['empty', 'closeResults']);
const hasSidebarResults = computed(() => {
    if (props.hits.notFound)
        return false;
    let has = false;
    props.hits.forEach((hit) => {
        if (hit.sidebar)
            has = true;
    });
    let col = 9;
    return {
        b: has,
        l: col,
    };
});
const hasMainbarResults = computed(() => {
    if (props.hits.notFound)
        return false;
    let has = false;
    props.hits.forEach((hit) => {
        if (!hit.sidebar)
            has = true;
    });
    return has;
});
const go = (where) => {
    router.visit(where + `?trackquery=${props.query}`);
    emit('empty');
};
const loading = ref(false);
const sendQuestion = () => {
    loading.value = true;
    if (email.value !== '' && question.value !== '') {
        router.post(route('search.contact'), {
            email: email.value,
            question: question.value,
            query: props.query,
        }, {
            onSuccess: () => {
                loading.value = false;
                email.value = '';
                question.value = '';
                emit('empty');
            },
        });
    }
};

const { xlAndUp, lg } = useDisplay();

const getWidthOfSearch = computed(() => {
    if (xlAndUp.value)
        return 1120;

    if (lg.value)
        return 890;

    return '100dvw';
});


const motorbike = computed(() => {
    return usePage().props.modelSearch?.model?.full_name;
});

const email = ref('');
const question = ref('');
const rules = {
    required: value => !!value || 'Toto pole je vyžadováno!',
    counter: value => value.length <= 20 || 'Maximálně 20 znaků',
    email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Toto není validní emailová adresa';
    },
};
const findMore = () => {
    let url = route('search.view', { 'query': props.query });
    go(url);
};

const hasSelected = computed(() => {
    let filters = Object.values(usePage().props.filtered);
    let selected = false;
    filters.forEach((item) => {
        if (Array.isArray(item) && item.length > 0) {
            selected = true;
        }
        if (item === true) {
            selected = true;
        }
    });
    return selected;
});

const searchStore = useSearchStore(pinia);

const cancelFilter = () => {
    router.get(route('eshop.forgetModelSearch'), {}, {
        onSuccess: () => {
            emit('closeResults');
            searchStore.resetSelected();
            router.visit(route('search.view', { query: props.query }));
        },
    });
};

const modelSearchStore = useOverlayModalsStore(pinia);
const selectModel = (model) => {
    emit('closeResults');
    emit('empty');
    searchStore.resetSelected();
    modelSearchStore.setModelSearchOpen(true);
    nextTick(() => {
        setTimeout(() => {
            searchStore.setSelected(model.type, model.brand, { cubature: model.cubature }, {
                name: model.name,
                id: model.id,
            });
        }, 200);
    });
};

</script>
<style scoped lang="scss">
@use '../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'sass:map';

$marginFromTop: 98px;
.c-active-tab {
    background: white !important;
    border: none !important;
}

.has-guy {
    width: 100%;
    height: 100%;
    position: relative;
    background-image: url('../../../assets/images/search/look.png');
    background-position: center bottom;
    background-size: contain;
    background-repeat: no-repeat;
    @media #{map.get($display-breakpoints, 'xs')} {
        background: none;
    }
}
.search-mobile-scroll {
    @media #{map.get($display-breakpoints, 'sm-and-down')} {
        overflow-y: scroll;
        height: 100%;
    }
}

.mobile-search-results-window {
    @media #{map.get($display-breakpoints, 'sm-and-down')} {
        height: calc(100dvh - $marginFromTop)!important;
        padding-bottom: 64px;
    }
}

.c-not-found {
    overflow: hidden;
}

.c-link {
    cursor: pointer;

    &:hover {
        text-decoration: none !important;
        background-color: map.get($orange, 'lighten-4');
        padding: 2px 5px;
        border-radius: 5px;
        margin: -2px -5px;
        color: map.get($orange, 'base')
    }
}
</style>
